export default __webpack_public_path__ + "static/media/order-presignature-pending.dc4035de.svg";